import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../../config";

const styles = {
  card: { border: "1px solid #ccc", borderRadius: 6, margin: "16px 0" },
  header: { textAlign: "center", fontWeight: 700, fontSize: 22, padding: "10px 8px" },
  table: { width: "100%", borderCollapse: "collapse" },
  th: { background: "#d9f0f2", border: "1px solid #000", padding: "10px", fontWeight: 700 },
  td: { border: "1px solid #000", padding: "10px" }
};

export default function BirthdayToday() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    (async () => {
      try {
        const { data } = await axios.get(`${API_BASE_URL}/birthdaysToday`, {
          headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
        });
        setRows(data?.data || []);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return rows?.length > 0 ?(
    // <div className="row clearfix">
	// 						<div className="col-12 col-sm-12">
	// 							<div className="card">
	// 								<div className="card-header">
	// 									<h3 className="card-title">Today Birthday Employees</h3>
	// 								</div>
	// 								<div className="card-body">
	// 									<div className="table-responsive">
	// 										<table className="table table-hover table-striped text-nowrap table-vcenter mb-0">
	// 											<thead>
	// 												<tr>
    //                                                 <th style={styles.th}>S.no</th>
    //                                                 <th style={styles.th}>Employee Id</th>
    //                                                 <th style={styles.th}>Employee Name</th>
    //                                                 <th style={styles.th}>Department Name</th>
    //                                             </tr>
    //                                             </thead>
    //     <tbody>
    //       {loading ? (
    //         <tr><td style={styles.td} colSpan={4}>Loading…</td></tr>
    //       ) : rows.length === 0 ? (
    //         <tr><td style={styles.td} colSpan={4}>No birthdays today 🎉</td></tr>
    //       ) : (
    //         rows.map((r, i) => (
    //           <tr key={`${r.employee_id}-${i}`}>
    //             <td style={styles.td}>{i + 1}</td>
    //             <td style={styles.td}>{r.employee_id}</td>
    //             <td style={styles.td}>{`${r.first_name || ""} ${r.last_name || ""}`.trim()}</td>
    //             <td style={styles.td}>{r.department_name || "-"}</td>
    //           </tr>
    //         ))
    //       )}
    //     </tbody>
    //   </table>
    // </div>
    //  </div>
    //   </div>
    //    </div>
    //     </div>


<div className="row clearfix">
							<div className="col-12 col-sm-12">
								<div className="card">
									<div className="card-header">
										 <h5 className="mb-0 text-center">
                                            <span role="img" aria-label="birthday-cake" style={{ fontSize: 22 }}>
                                                🎂🎂
                                            </span>{" "}
                                            Today Birthday Employees{" "}
                                            <span role="img" aria-label="bouquet" style={{ fontSize: 22 }}>
                                                💐
                                            </span>
                                            </h5>
									</div>
									<div className="card-body">
										<div className="table-responsive">
											<table className="table table-hover table-striped text-nowrap table-vcenter mb-0">
												<thead>
													<tr>
														<th>S.No</th>
														<th>Employee Id</th>
														<th>Employee Name</th>
														<th>Department Name</th>
													</tr>
												</thead>
												<tbody>
													  {rows.map((r, i) => (
                                                            <tr key={`${r.employee_id}-${i}`}>
                                                            <td>{i + 1}</td>
                                                            <td>{r.employee_id}</td>
                                                            <td>{`${r.first_name || ""} ${r.last_name || ""}`.trim()}</td>
                                                            <td>{r.department_name || "-"}</td>
                                                            </tr>
                                                        ))}
												</tbody>
											</table>
										</div>
									</div>
								</div>
							</div>
						</div>
  ) : null;
}
